/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailEditsQueryResponse, GetCompositionsDetailEditsPathParams } from "../models/GetCompositionsDetailEdits";

export function getGetCompositionsDetailEditsUrl(id: GetCompositionsDetailEditsPathParams["id"]) {
  const res = { method: 'GET', url: `/compositions/${id}/edits` as const }
  return res
}

/**
 * @summary List video-editor edits for a composition
 * {@link /compositions/:id/edits}
 */
export async function getCompositionsDetailEdits(id: GetCompositionsDetailEditsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetCompositionsDetailEditsUrl(id).url.toString(), ... requestConfig })
  return res.data
}